module.exports = __webpack_public_path__ + "media/src/images/course-placeholder-21e155b1ef50fc2f34ccf54d49fefdfd.jpg";